import {
  CartServiceBase,
  type ICartService,
} from 'shared/services/api/cartService/common'
import type { ServiceParameters } from 'shared/services/api/commonTypes'

const BACKEND_API_VERSION = 'v4'

class CartServiceV4 extends CartServiceBase implements ICartService {
  constructor(props: ServiceParameters) {
    super({ ...props, apiVersion: BACKEND_API_VERSION })
  }
}

export default CartServiceV4
